import Vue from "vue";
import AppWrapper from "./AppWrapper.vue";
import store from "./store";
import VTooltip from "v-tooltip";
import VueLazyload from "vue-lazyload";
import VueObserveVisibility from "vue-observe-visibility";
import router from "./router";
import ClickOutside from "vue-click-outside";
import {Fragment} from "vue-fragment";
import AppConfig from "@/classes/AppConfig";
//import Rest from "@/api/Rest";
import {getUrlParameter} from "@/utils";
import VueGTM from "vue-clean-gtm";
import {isArray} from "lodash";
import InstantSearch from "vue-instantsearch";
import Graphics from "@/components/graphics/Graphics";


//console.log("*** Iframe URL:", location.href, location);

//console.log('Process:', process, "   .env", process.env, " .env.VUE_APP_API_URL", process.env.VUE_APP_API_URL);

const start = async () => {

	await Graphics.init();

	const tp = getUrlParameter("_fc") || "";

	console.log('Pre Load Router:', router)

	await AppConfig.LoadConfig("app", tp, true, {location});
	// console.log("App Config Loaded:", AppConfig.AppConf);

	//Rest.Create();

	const doc = document.getElementById("icon");
	doc.href = `/icons/favicon/${AppConfig?.AppConf?.favicon}`;
	document.title = `${AppConfig?.AppConf?.title}`;


	Vue.config.productionTip = false;
	let analytics = AppConfig.AppConf?.analytics;

	console.log("Analytics Config:", analytics);


	if (!isArray(analytics)) {
		analytics = [analytics];
	}
	analytics.forEach((analytic) => {
		console.log("Analytic:", analytic);
		switch (analytic?.type) {
			case "GTM":
				if (analytic?.config) {
					Vue.use(VueGTM, analytic?.config);
				}
				break;
			case "QM":
				/*var qtm = document.createElement('script');qtm.type = 'text/javascript';qtm.async = 1;
				qtm.src = analytic.config.src;
				var d = document.getElementsByTagName('script')[0];
				window.QuantumMetricAPI && d.parentNode.insertBefore(qtm, d);*/


				var quantumMetricsScript = document.createElement("script");
				quantumMetricsScript.async = 1;
				quantumMetricsScript.src = analytic.config.src;
				document.body.appendChild(quantumMetricsScript);
				window.QuantumMetricAPI;
				break;

			case 'custom-script':
				if (!analytic?.config?.src && !(analytic?.env && analytic?.[`config-${analytic?.env}`]?.src)) return;
				var config = analytic?.[`config-${analytic?.env}`] || analytic?.config;
				var name = `${analytic.name || analytic.type}`;
				console.log(`Loading Analytics: ${name}`, config.src, config.target || "body")
				var beaconScript = document.createElement("script");
				beaconScript.async = config.async ?? false;// true;
				beaconScript.src = config.src;
				beaconScript.title = `Analytic: ${name}`;
				beaconScript.type = "text/javascript";
				document?.[config.target || "body"]?.appendChild(beaconScript);
				break;
		}
	});


	Vue.use(VTooltip);
	Vue.directive("tooltip", VTooltip.VTooltip);
	Vue.directive("close-popover", VTooltip.VClosePopover);
	Vue.component("v-popover", VTooltip.VPopover);
	Vue.component("fragment", Fragment);


	Vue.directive("click-outside", ClickOutside);

	Vue.use(VueLazyload, {
		observer: true
	});
	Vue.use(VueObserveVisibility);
	Vue.use(InstantSearch);

	Vue.filter("localizeCurrency", value => {
		if (typeof Number(value) !== "number") {
			return value;
		}
		let formatter = new Intl.NumberFormat(store.getters.language === "en" ? "en-US" : "fr-CA", {
			style: "currency",
			currency: "CAD"
		});
		return formatter.format(Number(value));
	});

	Vue.filter("currency", value => {
		if (typeof Number(value) !== "number") {
			return value;
		}
		let formatter = new Intl.NumberFormat(`${store.getters.language}-CA`, {
			style: "currency",
			currency: "CAD"
		});
		return formatter.format(Number(value));
	});

	new Vue({
		store,
		router,
		render: h => h(AppWrapper)
	}).$mount("#app");
};

start();
